/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: eyes360vr (https://sketchfab.com/eyes360vr)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/milk-test-4f8003c35c13451eaf176ba3e44de20b
title: Milk test
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function MilkModel(props) {
  const { nodes, materials } = useGLTF("../assets/models/milk_test/scene.glb");

  return (
    <group
      {...props}
      dispose={null}
      rotateOnAxis={Math.PI / 2}
      rotation={[0, -1, 0]}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh1_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh2_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh3_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh4_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh5_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh6_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh7_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh8_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh9_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh10_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh11_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh12_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh13_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh14_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh15_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh16_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh17_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh18_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh19_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh20_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh21_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh22_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh23_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh24_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh25_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh26_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh27_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh28_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh29_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh30_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh31_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh32_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh33_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh34_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh35_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh36_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh37_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh38_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh39_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh40_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh41_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh42_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh43_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh44_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh45_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh46_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh47_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh48_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh49_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh50_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh51_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh52_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh53_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh54_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh55_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh56_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh57_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh58_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh59_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh60_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh61_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh62_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh63_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh64_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh65_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh66_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh67_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh68_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh69_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh70_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh71_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh72_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh73_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh74_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh75_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh76_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh77_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh78_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh79_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh80_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh81_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh82_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh83_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh84_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh85_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh86_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh87_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh88_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh89_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh90_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh91_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh92_MT_Plastic_003_0.geometry}
            material={materials.MT_Plastic_003}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh93_EMBALAGEM_LEITE6_0.geometry}
            material={materials.EMBALAGEM_LEITE6}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh94_EMBALAGEM_LEITE6_0.geometry}
            material={materials.EMBALAGEM_LEITE6}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh95_FrontColor_0.geometry}
            material={materials.FrontColor}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh96_FrontColor_0.geometry}
            material={materials.FrontColor}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh96_EMBALAGEM_LEITE6_0.geometry}
            material={materials.EMBALAGEM_LEITE6}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh96_EMBALAGEM_LEITE4_0.geometry}
            material={materials.EMBALAGEM_LEITE4}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh96_EMBALAGEM_LEITE1_0.geometry}
            material={materials.EMBALAGEM_LEITE1}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh96_EMBALAGEM_LEITE2_0.geometry}
            material={materials.EMBALAGEM_LEITE2}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh96_EMBALAGEM_LEITE5_0.geometry}
            material={materials.EMBALAGEM_LEITE5}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Mesh97_FrontColor_0.geometry}
            material={materials.FrontColor}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("../assets/models/milk_test/scene.glb");
